<div style="margin-bottom: 10px;margin-top: -30px;margin-left: -17px;">
  <mat-slide-toggle [(ngModel)]="viewModel.isUseFtp" labelPosition="before" color="primary">Use FTP</mat-slide-toggle> 
  <div *ngIf="viewModel.isUseFtp">
    <app-ftp-service-select [value]="viewModel.ftpService" (valueChange)="onFtpChange($event)" (connectionStatusChange)="ftpConnectionStatus = $event"></app-ftp-service-select>
  </div>
</div>

<div style="margin-left: -13px;">
<div>
    <mat-form-field style="width: 790px;" appearance="outline">
        <mat-label>Developer Ingest File Path</mat-label>
        <input matInput [(ngModel)]="viewModel.inputFileNameExcel" placeholder="Enter the full path to the excel file" (blur)="handleBlur(viewModel.inputFileNameExcel)" readonly>
    </mat-form-field>
    <button mat-button (click)="showFileBrowserDialog()" class="big-icon-btn">
        <mat-icon>search</mat-icon>
    </button>
    <mat-form-field style="margin-right: 10px;" appearance="outline">
      <mat-label>Tab Name</mat-label>
      <mat-select 
      [(value)]="viewModel.sheetName" 
      [disabled]="viewModel.isMultiTabIngest">
      
      <!-- Include Multi-tab option only if viewModel.isMultiTabIngest is true -->
      <ng-container *ngIf="viewModel.isMultiTabIngest" style="color:#ff0000!important;">
        <mat-option value="Multi-tab" >Multi-tab</mat-option>
      </ng-container>
    
      <!-- Show other sheet options only if viewModel.isMultiTabIngest is false -->
      <ng-container *ngIf="!viewModel.isMultiTabIngest">
        <mat-option *ngFor="let sheet of viewModel.sheets" [value]="sheet">
          {{sheet}}
        </mat-option>
      </ng-container>
    
    </mat-select>
    
  </mat-form-field>
  
    <mat-form-field  appearance="outline" style="width: 163px;">
        <mat-label>Connection Timeout(s)</mat-label>
        <input matInput [(ngModel)]="viewModel.connectionTimeOut" type="number" placeholder="60" min="0">
    </mat-form-field>
</div>

<div>
    <mat-card-header style="background: inherit;padding: 0px !important;">
        <mat-card-title style="font-size: 14px; color: #c65f00; margin-left: 4px;  margin-top: -8px;margin-bottom: 16px;">
            <ng-container>
              Scheduler Ingest Configuration
            </ng-container>
        </mat-card-title>
    </mat-card-header>
    
    <div>
        <mat-form-field style="width: 790px" appearance="outline">
            <mat-label>Scheduler Directory</mat-label>
            <input matInput [(ngModel)]="viewModel.inputFileNameExcelScheduleDirectory" placeholder="Enter the full path" (blur)="handleBlurDirectory(viewModel.inputFileNameExcel)">
        </mat-form-field>
        <button mat-button (click)="browseDir()" class="big-icon-btn">
            <mat-icon>search</mat-icon>
        </button>
        <mat-form-field style="margin-right: 10px;" appearance="outline">
            <mat-label>Tab Name</mat-label>
            <input matInput [(ngModel)]="viewModel.scheduleSheetName" placeholder="Enter Tab Name" [disabled]="viewModel.isMultiTabIngest">
          
        </mat-form-field>
        <mat-form-field appearance="outline" style="width: 163px;">
            <mat-label>Connection Timeout(s)</mat-label>
            <input matInput [(ngModel)]="viewModel.scheduleConnectionTimeOut" type="number" placeholder="180"  min="0">
          </mat-form-field>
          
    </div>
    <div style="display: flex; align-items: center;" >
        <!-- Base File Name Field -->
        <mat-form-field style="width: 400px; margin-right: 16px;" appearance="outline">
          <mat-label>Base File Name</mat-label>
          <input matInput [(ngModel)]="viewModel.baseFileName" placeholder="Enter the base file name">
        </mat-form-field>
      
        <!-- Date-Time Extension Field -->
        <mat-form-field style="width: 200px; margin-right: 16px;" appearance="outline">
          <mat-label>Datetime extension</mat-label>
          <mat-select [(ngModel)]="viewModel.dateTimeExtension" (selectionChange)="onFormatChange($event.value)" >
            <mat-option value="yyyy-MM-dd">YYYY-MM-DD*</mat-option>
            <mat-option value="MM-dd-yyyy">MM-DD-YYYY*</mat-option>
            <mat-option value="M-dd-yy">MM-DD-YY*</mat-option>
          </mat-select>
         
        </mat-form-field>
      
       
          <!-- File Extension Dropdown -->
          <mat-form-field appearance="outline" style="width: 150px;">
            <mat-label>File extension</mat-label>
            <mat-select [(ngModel)]="viewModel.fileExtension">
              <mat-option value=".xlsx">.xlsx</mat-option>
              <mat-option value=".xls">.xls</mat-option>
              <mat-option value=".slk">.slk</mat-option>
            </mat-select>
          </mat-form-field>
        
          <div style="margin-left: 20px; display: flex; flex-direction: column; justify-content: center;">
            <!-- Sample File Name Label -->
            <span style="color: #d1cfcf; font-size: 10px;">Sample File Name</span>
            
            <!-- Sample File Name Value -->
            <span style="color: #d1cfcf;">
                {{viewModel.baseFileName}}{{ formattedDate }}{{viewModel.fileExtension}}
            </span>
          </div>
      
      
      
</div>

<div>
  <fieldset class="outer-box" style="width: 600px; margin-top: 1px; margin-left: 3px;">
    <legend class="box-label">If multiple matches</legend>
  
    <mat-form-field appearance="outline" style="width: 400px; margin-right: 16px; margin-left: 10px; margin-bottom: 0px;">
      <mat-select [(ngModel)]="viewModel.selectedInstance" 
                  (selectionChange)="onSelectionChange($event.value)" 
                  [panelClass]="'custom-dropdown'">
                  
        <mat-option value="">select</mat-option>
        <mat-option value="first">First instance</mat-option>
        <mat-option value="nth">nth instance</mat-option>
        <mat-option value="last">Last instance</mat-option>
      </mat-select>
    </mat-form-field>
  
    <mat-form-field appearance="outline" style="width: 100px;   margin-bottom:  8px   !important;margin-left: 1px;">
      <mat-label>Instance</mat-label>
      <input matInput placeholder="n" 
             [(ngModel)]="viewModel.nValue" 
             type="number" 
             [disabled]="isInstanceDisabled" 
             min="1">
    </mat-form-field>
</fieldset>

</div>
</div>
